import { VSelect } from 'vuetify/lib/components/VSelect';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c(VSelect,_vm._b({attrs:{"items":_vm.items,"value":_vm.localeValue,"label":"Language","outlined":"","loading":_vm.loading,"loader-height":"5"},on:{"change":_vm.handleChange}},'v-select',_vm.$attrs,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }